<template>
  <section>
    <b-form-group :label="$t('FROM')" class="mt-2">
      <b-form inline>
        <datetime
          class="mr-2"
          id="meeting_from_month"
          auto
          value-zone="UTC"
          @close="changeFromDate"
          input-class="form-control"
          v-model="meeting_from_month"
        ></datetime>

        <datetime
          id="meeting_from_time"
          type="time"
          auto
          value-zone="UTC"
          @close="checkFrom"
          input-class="form-control"
          :minute-step="5"
          v-model="meeting_from"
        ></datetime>
      </b-form>
    </b-form-group>

    <b-form-group :label="meetingDuration" class="mt-2">
      <b-form inline>
        <datetime
          class="mr-2"
          id="meeting_to_month"
          auto
          value-zone="UTC"
          @close="changeToDate"
          input-class="form-control"
          v-model="meeting_to_month"
        ></datetime>

        <datetime
          id="meeting_to_time"
          type="time"
          auto
          value-zone="UTC"
          input-class="form-control"
          @close="changedTo"
          :minute-step="5"
          v-model="meeting_to"
        ></datetime>
      </b-form>
    </b-form-group>
  </section>
</template>
<script>
import { Datetime } from "vue-datetime";
export default {
  components: {
    datetime: Datetime,
  },
  data() {
    return {
      meeting_from: "",
      meeting_to: "",
      meeting_from_month: "",
      meeting_to_month: "",
      current_time: "",
      today: new Date(
        new Date().getFullYear(),
        new Date().getMonth(),
        new Date().getDate()
      )
    };
  },
  methods: {
    changedTo() {
      this.$emit("changedTo", this.meeting_to);
    },
    changeFromDate() {
      let new_month = this.meeting_from_month.substring(0, 11);
      let old_time = this.meeting_from.slice(11);
      this.meeting_from = new_month + old_time;
      this.checkFrom();
    },
    changeToDate() {
      let new_month = this.meeting_to_month.substring(0, 11);
      let old_time = this.meeting_to.slice(11);
      this.meeting_to = new_month + old_time;
      this.$emit("changedTo", this.meeting_to);
    },
    checkFrom() {
      if (this.meeting_from >= this.meeting_to) {
        this.meeting_to = this.$luxonDateTime
          .fromISO(this.meeting_from)
          .plus({ minutes: 30 })
          .toUTC()
          .toISO();
        this.meeting_to_month = this.meeting_to;
      }
      this.$emit("changedTo", this.meeting_to);
      this.$emit("changedFrom", this.meeting_from);
    },
    async init() {
      let currentTime = new this.$luxonDateTime.utc().set({
        seconds: 0,
        milliseconds: 0,
      });
      let minute = currentTime.minute;
      let add_minutes = 0;
      if (minute < 30) {
        add_minutes = 30 - minute;
      }
      if (minute > 30 && minute <= 60) {
        add_minutes = 60 - minute;
      }
      let new_time = currentTime.plus({ minutes: add_minutes });
      let next_time = new_time.plus({ minutes: 30 });
      this.meeting_from = new_time.toISO();
      this.meeting_to = next_time.toISO();
      this.meeting_from_month = this.meeting_from;
      this.meeting_to_month = this.meeting_to;
      this.$emit("changedTo", this.meeting_to);
      this.$emit("changedFrom", this.meeting_from);
    },
    startFromDate(minutes) {
      let d = new Date();
      let ms = 1000 * 60 * minutes;
      let roundedDate = new Date(Math.round(d.getTime() / ms) * ms);
      return roundedDate.toISOString();
    },
  },
  computed: {
    meetingDuration: function () {
      let duration = "";
      if (this.meeting_from < this.meeting_to) {
        const b = this.$luxonDateTime.fromISO(this.meeting_from);
        const a = this.$luxonDateTime.fromISO(this.meeting_to);
        var dur = this.$luxonInterval.fromDateTimes(b, a);
        let minutes = dur.length("minutes");
        let hours = dur.length("hours");
        let days = dur.length("days");
        hours = Math.floor(hours);
        days = Math.floor(days);
        let minutesLeft = minutes - hours * 60;
        let hoursLeft = hours - days * 24;
        if (minutesLeft >= 1) {
          duration = minutesLeft + " " + this.$t("DURATION.MINUTE");
        }
        if (hoursLeft >= 1) {
          duration = hoursLeft + this.$t("DURATION.HOUR") + " " + duration;
        }
        if (days >= 1) {
          duration = days + this.$t("DURATION.DAY") + " " + duration;
        }
        return this.$t("TO") + " (" + duration + ")";
      } else {
        return this.$t("TO");
      }
    },
    disabledFirst: function () {
      if (this.emails.length != 0 && this.subject != "") {
        return false;
      } else {
        return true;
      }
    },
    disabledSecond: function () {
      if (this.external_participants.length != 0) {
        if (
          this.external_participants.length == this.validatedParticipants.length
        ) {
          return false;
        } else {
          return true;
        }
      } else {
        return true;
      }
    },
    open_to_date() {
      if (this.set_open_to_date == 1) {
        return this.to_date;
      }
      return null;
    },
    open_from_date() {
      if (this.set_open_from_date == 1) {
        return this.from_date;
      }
      return null;
    },
    selectedOpenToDate() {
      if (this.to_date_month == "" || this.to_date_time == "") {
        return ": " + this.$t("NOT_SELECTED");
      }
      return this.to_date_month + " " + this.to_date_time;
    },
    selectedOpenFromDate() {
      if (this.from_date_month == "" || this.from_date_time == "") {
        return ": " + this.$t("NOT_SELECTED");
      }
      return this.from_date_month + " " + this.from_date_time;
    },
    canVerify() {
      if (this.emails.length == 0) {
        return false;
      }
      if (this.subject == "") {
        return false;
      }
      return true;
    },
    validatedParticipants() {
      return this.validated.filter(function (item) {
        return item.valid == 1;
      });
    },
  },
  watch: {
    set_loa_level: function (val) {
      if (val == 0) {
        this.loa_level = 1;
      }
    },
  },
  mounted() {
    this.init();
  },
};
</script>
  